import '../styles/SeccionCategorias.css';

const PLACEHOLDER_ICONS = {
  default: '🪑',
};

export default function SeccionCategorias({ categorias, categoriaActiva, onSeleccionar }) {
  const padres = categorias
    .filter(c => !c.parent_id)
    .sort((a, b) => a.nombre.localeCompare(b.nombre));

  if (padres.length === 0) return null;

  return (
    <section className="sc-seccion">
      <div className="sc-titulo-wrap">
        <h2 className="sc-titulo">Explorá por categoría</h2>
        <div className="sc-titulo-linea" />
      </div>
      <div className="sc-grid">
        {padres.map(cat => {
          const activa = categoriaActiva === cat.nombre;
          return (
            <button
              key={cat._id}
              className={`sc-card${activa ? ' sc-card-activa' : ''}`}
              onClick={() => onSeleccionar(activa ? '' : cat.nombre)}
              title={activa ? `Quitar filtro: ${cat.nombre}` : `Ver ${cat.nombre}`}
            >
              {cat.imagen ? (
                <img src={cat.imagen} alt={cat.nombre} className="sc-img" />
              ) : (
                <div className="sc-img-placeholder">{PLACEHOLDER_ICONS.default}</div>
              )}
              <div className="sc-overlay">
                <span className="sc-nombre">{cat.nombre}</span>
                {activa && <span className="sc-activa-tag">✓ Filtrando</span>}
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
